/**
 * @file ContactPage.jsx
 * @description Página de contacto y cotizaciones de AGDYSA.
 */
import { useEffect } from "react";
import { motion } from "framer-motion";
import { useLocation } from "react-router-dom";
import QuotationForm from "../components/QuotationForm";

const ContactPage = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.fromBasket) {
      const timer = setTimeout(() => {
        document.getElementById("quotation-form")?.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 300);
      return () => clearTimeout(timer);
    }
    return undefined;
  }, [location.state]);

  return (
    <motion.div 
      initial={{ opacity: 0 }} 
      animate={{ opacity: 1 }} 
      exit={{ opacity: 0 }}
      className="pt-40 pb-20 bg-surface min-h-screen font-body"
    >
      <div className="container mx-auto px-6 text-center">
        <header className="max-w-3xl mx-auto mb-16">
          <motion.span 
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            className="text-brand-primary font-bold uppercase tracking-[0.3em] text-xs mb-4 block"
          >
            Gestión de Proyectos
          </motion.span>
          <h1 className="font-display text-5xl md:text-6xl font-black text-brand-dark mb-6 tracking-tighter leading-tight">
            Contacto y <span className="text-brand-primary italic">Cotizaciones</span>
          </h1>
          <p className="text-lg md:text-xl text-brand-dark/60 font-medium leading-relaxed">
            Gracias por su interés. Complete el formulario para que nuestro equipo técnico prepare una propuesta económica adaptada a sus necesidades.
          </p>
        </header>

        {/* FORMULARIO DE COTIZACIÓN INTEGRADO */}
        <div id="quotation-form">
          <QuotationForm />
        </div>

        <footer className="mt-16 max-w-2xl mx-auto">
          <p className="text-sm text-brand-dark/40 font-bold uppercase tracking-widest italic">
            AGDYSA – Especialistas en Seguridad y Salud Ocupacional.
          </p>
        </footer>
      </div>
    </motion.div>
  );
};

export default ContactPage;